import { render } from "./jiezhi_data.vue?vue&type=template&id=19fd338b&scoped=true"
import script from "./jiezhi_data.vue?vue&type=script&lang=js"
export * from "./jiezhi_data.vue?vue&type=script&lang=js"

import "./jiezhi_data.vue?vue&type=style&index=0&id=19fd338b&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fd338b"]])

export default __exports__